module.exports = __webpack_public_path__ + "static/04_AZ-PC-Tulsa-Procedure-Prostate-Website-f7b7439fe41a7b692c616b4a18d8d5a2.jpg";